
G.connectComponent(G.routes.LOGIN_FORM_COMPONENT, function(C) {
	C.ajaxFormOnSubmit({
		form: C.$container.find('.login-form'),
		ajax_function: `submitLoginForm`,
		error_message: 'Login failed.',
		success_message: false,
		loading: false,
	});
});